import { type UseInViewOptions, useInView } from "framer-motion";
import { useRef } from "react";

export function useScrollReveal(options?: {
  once?: boolean;
  margin?: UseInViewOptions["margin"];
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: options?.once ?? true,
    // SAFETY: framer-motion types the margin as a branded string; "-40px 0px" is a valid margin literal.
    margin: options?.margin ?? ("-40px 0px" as UseInViewOptions["margin"]),
  });
  return { ref, isInView };
}
